export function returnColor(val) {
  let color = "";
  if (val === "0" || val === "不通过" || val === "审核不通过") {
    // 审核不通过
    color = "#CF2224";
  } else if (
    val === "1" ||
    val === "通过" ||
    val === "已通过" ||
    val === "审核通过"
  ) {
    // 审核通过
    color = "#41B29C";
  } else if (
    val === "3" ||
    val === "待审核" ||
    val === "2" ||
    val === "审核中"
  ) {
    // 待审核
    color = "#FFA400";
  } else {
    color = "#999999";
  }
  return { color };
}
export function returnTkText(val) {
  if (val === "0" || val === "不通过" || val === "审核不通过") {
    // 审核不通过
    return "审核不通过";
  } else if (
    val === "1" ||
    val === "通过" ||
    val === "已通过" ||
    val === "审核通过"
  ) {
    // 审核通过
    return "审核通过";
  } else if (val === "2" || val === "审核中") {
    // 审核中
    return "审核中";
  } else if (val === "3" || val === "待审核") {
    // 待审核
    return "待审核";
  } else {
    return "暂无状态";
  }
}

export function returnUrl(val) {
  if (val === "0" || val === "不通过" || val === "审核不通过") {
    // 审核不通过
    return "btg";
  } else if (
    val === "1" ||
    val === "通过" ||
    val === "已通过" ||
    val === "审核通过"
  ) {
    // 审核通过
    return "ytg";
  } else if (val === "2" || val === "审核中") {
    // 审核中
    return "shz";
  } else if (val === "3" || val === "待审核") {
    // 待审核
    return "dsh";
  } else if (val === "warn") {
    // 待审核
    return "warn";
  }
}

export function returnFileType(flag) {
  if (flag == "doc") {
    return "doc";
  } else if (flag == "excel") {
    return "excel";
  } else if (flag == "mv4") {
    return "mv4";
  } else if (flag == "pdf") {
    return "pdf";
  } else if (flag == "png" || flag == "jpg") {
    return "png";
  } else if (flag == "ppt") {
    return "ppt";
  } else if (flag == "txt") {
    return "text";
  } else if (flag == "vedio") {
    return "vedio";
  } else if (flag == "zip") {
    return "zip";
  } else {
    return "unKnow";
  }
}



// WEBPACK FOOTER //
// ./src/utils/exChang.js